import gql from "graphql-tag";
const ADD_EMAILS_HEADINGS = gql `
  mutation addEmailsHeading($emailsHeadingAddInput: EmailsHeadingAddInput!) {
    addEmailsHeading(emailsHeadingAddInput: $emailsHeadingAddInput) {
      id
    }
  }
`;
export default ADD_EMAILS_HEADINGS;
